
(function($, document, window) {

	$(function() {
		// jQuery ready!
	});

	const modalTrigger = $('a[href*="open-modal:"]'),
		modalCloseTrigger = $('.bnf-modal>.modal>.modal-header>.close');

	modalTrigger.click(function(event) {
		event.preventDefault();
		
		const [call, target] = this.href.split(':');
		const modal = $(`${target}`);

		if(modal.length > 0) {
			modal.addClass('-active');
			$('body').addClass('overflow-hidden');
		}
	});

	modalCloseTrigger.click(function() {
		const parent = $(this).parents('.bnf-modal');

		parent.removeClass('-active');
		$('body').removeClass('overflow-hidden');
	});

}(window.jQuery, document, window));